import farmerOnboardingService from 'services/farmerOnboarding';

export const importFarmers = async (file) => {
  try {
    const formData = new FormData();
    formData.append('UploadedFile', file, file.name);
    const response = await farmerOnboardingService.importFarmers(formData);
    return response;
  } catch (error) {
    console.error('Error importing farmers:', error);
    throw error;
  }
};
